import { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { scroller } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FirstFoolList, secondFoolList, coffeeShopFoolList, thirdFloorList } from './data';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useScroll, motion } from 'framer-motion';
export default function Services() {
  const sectionVariants = {
    hidden: { y:-100 },
    visible: {
     y:0,
      transition: {
        staggerChildren: 0.1,
        when: "beforeChildren"
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };
  const textVariants={
    hidden:{opacity:0,x:-50 },
    visible: { opacity: 1, x: 0 }
  }
  const [firstFloor, setFirstFloor] = useState(true);
  const [secondFloor, setSecondFloor] = useState(true);
  const [thirdFloor, setThirdFloor] = useState(true);
  
  const firstFloorRef = useRef(null);
  const secondFloorRef = useRef(null);
  const thirdFloorRef = useRef(null);

  const handleFloorClick = (floorState, setFloorState, ref, sectionId) => {
    const wasClosed = !floorState;
    setFloorState(!floorState);
    
    if (wasClosed) {
      setTimeout(() => {
        if (ref.current) {
          scroller.scrollTo(sectionId, {
            smooth: true,
            offset: -100,
            duration: 500
          });
        }
      }, 100);
    }
  };

  return (
    <div id='service'>
      <motion.div className="container"
      
      initial="hidden"
whileInView="visible"
viewport={{ once: true, amount: 0.2 }}
variants={sectionVariants}
>
   

   
        <div className="service-container">
          <motion.h1 className="section-title_"
          // variants={itemVariants}
          >
              خدماتنا
         
          </motion.h1>
          
          
          <ul className="service-list">
            <motion.li onClick={() => handleFloorClick(firstFloor, setFirstFloor, firstFloorRef, 'firstFloor')}
              // variants={itemVariants}
              >
            الطابق الاول
            {!firstFloor ? <FontAwesomeIcon icon={faAngleDown} className='arrow-icon'/> : <FontAwesomeIcon icon={faAngleUp} className='arrow-icon'/>}
            </motion.li>
           <motion.li onClick={() => handleFloorClick(secondFloor, setSecondFloor, secondFloorRef, 'secondFloor')}
            
            // variants={itemVariants}
            >
       
              الطابق الثاني
              {!secondFloor ? <FontAwesomeIcon icon={faAngleDown} className='arrow-icon'/> : <FontAwesomeIcon icon={faAngleUp} className='arrow-icon'/>}
           
           </motion.li>
            <motion.li onClick={() => handleFloorClick(thirdFloor, setThirdFloor, thirdFloorRef, 'thirdFloor')}  
            // variants={itemVariants}
            >
           
              الطابق الثالث
              {!thirdFloor ? <FontAwesomeIcon icon={faAngleDown} className='arrow-icon'/> : <FontAwesomeIcon icon={faAngleUp} className='arrow-icon'/>}
            
            </motion.li>
            
          </ul>

          {firstFloor && (
            <div className="first-floor" id="firstFloor" ref={firstFloorRef}>
              <h1 className="section-title">الطابق الاول</h1>
              <p className='description-section'>
                ألعاب إلكترونية مزودة بأحدث الإصدارات وإنترنت سريع وبي سي قيمنق
              </p>
              <div className="services-wrapper">
                <Swiper
                  modules={[Navigation, Pagination]}
                  spaceBetween={30}
                  slidesPerView={1}
                  navigation
                  pagination={{ clickable: true }}
                  breakpoints={{ 640: { slidesPerView: 2 }, 1024: { slidesPerView: 3 }}}
                  className="services-swiper"
                >
                  {FirstFoolList.map((service) => (
                    <SwiperSlide key={service.id}>
                      <motion.div className="service-card"  variants={itemVariants}>
                     
                        <img src={service.image} alt={service.title} className="card-image" />
                        <h4 className="service-title">{service.title}</h4>
                        <p className="service-description">{service.description}</p>
                        <a href='https://wa.me/+966507737006'>
                          <button className="btn service-btn">تواصل معنا</button>
                        </a>
                     
                      </motion.div>
                     
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          )}

          {secondFloor && (
            <div className="second-floor-section" id="secondFloor" ref={secondFloorRef}>
              <h1 className="section-title">الطابق الثاني</h1>
              <p className='description-section'>
                هنا يُصنع الأبطال ويتم التعرف على أقوى المنافسين ويستقبل نادينا البطولات العالمية لجودة المواد المستخدمة
              </p>
              <div className="second-floor">
                <motion.div className="enjoy-section" 
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={sectionVariants}
                >
                
                  <h1 className="section-title">قسم الترفيهه</h1>
                  <motion.img 
                  src={require('../images/1745310217468.jpg')} alt='no-image' className='enjoy-main-img'
                  variants={itemVariants}
                  >
              
                  </motion.img>
                  <motion.div className="services-wrapper"
                  variants={sectionVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  >
                 
                    <Swiper
                      modules={[Navigation, Pagination]}
                      spaceBetween={30}
                      slidesPerView={1}
                      navigation
                      pagination={{ clickable: true }}
                      breakpoints={{ 640: { slidesPerView: 2 }, 1024: { slidesPerView: 3 }}}
                      className="services-swiper"
                    >
                      {secondFoolList.map((service) => (
                        <SwiperSlide key={service.id}>
                          <motion.div className="service-card" variants={itemVariants}>
                       
                            <img src={service.image} alt={service.title} className="card-image floot2-img" />
                            <h4 className="service-title">{service.title}</h4>
                            <p className="service-description">{service.description}</p>
                            <a href='https://wa.me/+966507737006'>
                              <button className="btn service-btn">تواصل معنا</button>
                            </a>
                         
                          </motion.div>
                          
                        </SwiperSlide>
                      ))}
                    </Swiper>
                
                  </motion.div>
                  
                
                </motion.div>

                <motion.div className="coffeeShop-section" variants={sectionVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                >


                  <h1 className="section-title">كوفي شوب</h1>
                  <p className='description-section'>
                    لعبة تحسين المزاج يحترفها مقهانا المزود بآلالات نادرة حول العالم ومحاصيل خاصة لعائلة بوكيت
                  </p>
                  <motion.img  src={require('../images/coffee-making-concept-with-machine.jpg')} alt='no-image' className='enjoy-main-img'
                  variants={itemVariants}
                  >

                  </motion.img>
                  <motion.div className="services-wrapper" variants={sectionVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  >

                    <Swiper
                      modules={[Navigation]}
                      spaceBetween={30}
                      slidesPerView={1}
                      navigation
                      breakpoints={{ 640: { slidesPerView: 2 }, 1024: { slidesPerView: 3 }}}
                      className="services-swiper"
                    >
                      {coffeeShopFoolList.map((service) => (
                        <SwiperSlide key={service.id}>
                          <motion.div  className="service-card floot2-img" 
                          variants={itemVariants}
                          >

                            <img src={service.image} alt={service.title} className="card-image" />
                            <h4 className="service-title coffee-card-title">{service.title}</h4>
                            <a href='https://wa.me/+966507737006'>
                              <button className="btn service-btn coffee-btn">تواصل معنا</button>
                            </a>
                     
                          </motion.div>
                          
                        </SwiperSlide>
                      ))}
                    </Swiper>
              
                  </motion.div>
                  
            
                </motion.div >


              </div>
            </div>
          )}

          {thirdFloor && (
            <div className="third-floor" id="thirdFloor" ref={thirdFloorRef}>
              <h1 className="section-title">الطابق الثالث</h1>
              <p className='description-section'>بوكيت هو مكانك الرحب الذي يرحب بك دائمًا</p>
              <motion.div className="services-wrapper" 
              variants={sectionVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              >
 
                <Swiper
                  modules={[Navigation, Pagination]}
                  spaceBetween={30}
                  slidesPerView={1}
                  navigation
                  pagination={{ clickable: true }}
                  breakpoints={{ 640: { slidesPerView: 2 }, 1024: { slidesPerView: 2 }}}
                  className="services-swiper"
                >
                  {thirdFloorList.map((service) => (
                    <SwiperSlide key={service.id}>
                      <motion.div className="service-card" variants={itemVariants}>
                   
                        <img src={service.image} alt={service.title} className="card-image" />
                        <h4 className="service-title">{service.title}</h4>
                        <p className="service-description">{service.description}</p>
                        <a href='https://wa.me/+966507737006'>
                          <button className="btn service-btn">تواصل معنا</button>
                        </a>
                      
                      </motion.div>
                     
                    </SwiperSlide>
                  ))}
                </Swiper>
              
              </motion.div>
             
            </div>
          )}
        </div>
   
      </motion.div>
      
    </div>
  );
}